module.exports = __webpack_public_path__ + "img/logo.7fdb0696.png";